var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"py-3 mt-3",attrs:{"flat":_vm.isFlat}},[_c('form-group',{attrs:{"title":"Imagens da fachada"}},[_c('v-row',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }